import { Box, Typography } from "@mui/material";
import Theme from "../../../../utils/Theme";

const notificationLabel = (appointmentPreference) => {
  if (appointmentPreference === 1) return "Email";
  if (appointmentPreference === 2) return "Text";
  if (appointmentPreference === 3) return "None";
  return "N/A";
};

const ymmTitle = (row) => {
  const parts = [row.make_year, row.make, row.model].filter(Boolean);
  return parts.length ? parts.join(" ") : "Vehicle details N/A";
};

const preferenceLabel = (preference) => {
  return preference || "N/A";
};

const formatAppointmentDateTime = (row) => {
  const date =
    row?.date ?? row?.appointment_date ?? null;
  const time =
    row?.time ?? row?.appointment_time ?? null;
  return [date, time].filter(Boolean).join(" ");
};

const AppointmentService = ({ vehicleAppointments, appointmentPreference }) => {
  const rows = (vehicleAppointments || []).filter((row) => row.appointment_set);

  if (rows.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Typography>No Data Available</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {rows.map((row, index) => {
        const dateTime = formatAppointmentDateTime(row);

        return (
          <Box
            key={`${row.vehicle_id ?? "appt"}-${index}`}
            sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
          >
            <span style={{ fontWeight: "bold", fontSize: 14 }}>
              {ymmTitle(row)}
            </span>
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              {row.vin && (
                <span>
                  VIN:{" "}
                  <span style={{ color: Theme.palette.primary.main }}>
                    {row.vin}
                  </span>
                </span>
              )}
              <span>
                Date & Time:{" "}
                <span style={{ color: Theme.palette.primary.main }}>
                  {dateTime || "N/A"}
                </span>
              </span>
              <span>
                Preference: {preferenceLabel(row.preference)}
              </span>
              {/* <span>
                Appointment Notification:{" "}
                <span style={{ color: Theme.palette.primary.main }}>
                  {notificationLabel(appointmentPreference)}
                </span>
              </span> */}
            </div>
          </Box>
        );
      })}
    </Box>
  );
};

export default AppointmentService;
